import Icon from '@ant-design/icons/es/components/Icon';
import oktaIcon from 'images/okta-icon.svg';
import React from 'react';

export const OktaIcon: React.FC = () => <Icon component={ () => <img src={ oktaIcon } /> } />;
